export default __webpack_public_path__ + "static/media/info-holo.42a218ee.svg";